import React from 'react'
import { ModalInjectedProps, Modal } from '@sketch/components'

export const PartialShareModal = ({ hideModal }: ModalInjectedProps) => {
  return (
    <Modal onCancel={hideModal}>
      <Modal.Body>wow</Modal.Body>
    </Modal>
  )
}
